<template>
    <el-dialog
        v-model="dialogShow"
        :title="title"
        :width="width" 
        :top="top"
        :before-close="handleClose"
        destroy-on-close
        >
        <div>
            <div class="block">
                <div class="hint">{{hint}}</div>
                <div class="dv-back">
                    <input v-model="inputText" spellcheck="false" class="dialog_input" type="text" v-focus @keyup.enter="selectButton(true)"/>
                </div>
            </div>
            <ConfirmButton class="mmp" @buttonClick="selectButton" :space="30"></ConfirmButton>
        </div>
    </el-dialog>
  </template>
  
  <script>
  import ConfirmButton from '../ConfirmButton.vue'
  export default {
    name: 'InputDialog',
    components:{
        ConfirmButton
    },
    props: {
      showDialog:Boolean,
      title:{
        type:String,
        default:"输入"
      },
      hint:{
        type:String,
        default:"请输入内容"
      },
      width:{
        type:String,
        default:"370px"
      },
      top:{
        type:String,
        default:"150px"
      },
      defaultText:{
        type:String,
        default:""
      }
    },
    watch:{
        showDialog:function(nval,old){
            this.dialogShow = nval
        },
        defaultText:function(nval,old){
            this.inputText = nval
        }
    },
    data(){
        return {
            dialogShow:this.showDialog,
            inputText:this.defaultText
        }
    },
    methods:{
        ///选择按钮
        selectButton:function(result){
            var res = {
                confrim:result,
                text:this.inputText.trim()
            }
            this.inputText=""
            this.$emit("selectButton",res)
        },
        handleClose:function(){
          this.selectButton(false)
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .mmp{
    margin-top: 50px;
    margin-bottom: 20px;
  }
  .block{
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;
    margin-top: 10px;
  }
  .input{
    width: 100%;
    border: none;
    outline: none;
    height: 35px;
  }
  .dv-back{
    background: var(--ans-input-back);
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .hint{
    color:var(--ek-text-color2);
  }
  </style>
  